import { TDataset } from '../../../models/aibuilder/aibuilder';
import { TrainingSample } from './useImageModel';

export function buildTrainingSamples(dataset: TDataset): TrainingSample[] {
  const labels = dataset.labels || [];
  const samples = dataset.samples || [];
  const byId = new Map(labels.map((label) => [label.id, label.name]));
  return samples
    .filter(
      (sample) => !sample.excluded && sample.content_url && sample.label_id && byId.get(sample.label_id),
    )
    .map((sample) => ({
      url: sample.content_url as string,
      label: byId.get(sample.label_id as number) as string,
    }));
}
